import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { connect } from 'react-redux';
import moment from 'moment';

import { getDate, getMonthDate } from 'lib/commonLib';

import Icon from 'components/atoms/Icon';
import MbTooltip from 'components/atoms/MbTooltip';
import MbButton from 'components/atoms/MbButton';
import SizeTypeFilter from 'components/molecules/Filter/SizeTypeFilter';
import MediaTpCodeFilter from 'components/molecules/Filter/MediaTpCodeFilter';
import DisplayFilter from 'components/organisms/DisplayFilter';
import ExternalFilter from 'components/organisms/ExternalFilter';
import DateRangePicker from 'components/organisms/DatePicker/DateRangePicker';
import TimeFilter from 'components/organisms/TimeFilter';
import SingleDate from 'components/organisms/DatePicker/SingleDate';
import ManagerFilter from 'components/organisms/ManagerFilter';
import FilterCollection from 'components/organisms/FilterCollection';

let sDate = null;
let eDate = null;
let advrtsPrdtCode = null;
let advrtsTpCode = null;
let itlTpCode = null;
let diffSDate = null;
let diffEDate = null;
let stdDttm = null;
let statsMth = null;
let initParam = {};

class StatisticsCommonFilter extends React.Component {
  constructor(props) {
    super(props);
    const {
      t,
      platformCodeList: pCodeList,
      getParam,
      initData = {},
      noneDate,
      useDiffDate,
      location,
      pltfomTpCodeDetailFilter, // 유형구분 (APP, 모바일웹 추가관련)
      noneExternalFilter, //외부연동
      useSingleDate,
      useMonthDate,
      externalUseRtb = false,
    } = props;
    const now = moment();
    if (useDiffDate) {
      diffSDate = moment().add(-1, 'day');
      diffEDate = moment().add(-1, 'day');
      sDate = moment().add(-2, 'day');
      eDate = moment().add(-2, 'day');

      if (typeof initData.sDate !== 'undefined') {
        sDate = moment(initData.sDate, 'YYYYMMDD');
      }
      if (typeof initData.eDate !== 'undefined') {
        eDate = moment(initData.eDate, 'YYYYMMDD');
      }
      if (typeof initData.diffSDate !== 'undefined') {
        diffSDate = moment(initData.diffSDate, 'YYYYMMDD');
      }
      if (typeof initData.diffEDate !== 'undefined') {
        diffEDate = moment(initData.diffEDate, 'YYYYMMDD');
      }

      initParam = {
        sDate: getDate(sDate),
        eDate: getDate(eDate),
        diffSDate: getDate(diffSDate),
        diffEDate: getDate(diffEDate),
      };
    } else if (useSingleDate) {
      if (!useMonthDate) {
        stdDttm = moment().add(-8, 'day');

        if (typeof initData.stdDttm !== 'undefined') {
          stdDttm = moment(initData.stdDttm, 'YYYYMMDD');
        }

        initParam = {
          stdDttm: getDate(stdDttm),
        };
      } else {
        statsMth = moment().add(-1, 'month').format('YYYYMM');

        if (typeof initData.statsMth !== 'undefined') {
          statsMth = moment(initData.statsMth, 'YYYYMM');
        }

        initParam = {
          statsMth: getMonthDate(statsMth),
        };
      }
    } else {
      if (!noneDate) {
        sDate = moment(now.format('YYYY-MM-01'));
        eDate = now;

        if (typeof initData.sDate !== 'undefined') {
          sDate = moment(initData.sDate, 'YYYYMMDD');
        }
        if (typeof initData.eDate !== 'undefined') {
          eDate = moment(initData.eDate, 'YYYYMMDD');
        }

        const query = queryString.parse(location.search);

        if (typeof query.sDate !== 'undefined') {
          sDate = moment(query.sDate, 'YYYYMMDD');
        }
        if (typeof query.eDate !== 'undefined') {
          eDate = moment(query.eDate, 'YYYYMMDD');
        }

        initParam = {
          sDate: getDate(sDate),
          eDate: getDate(eDate),
        };

        if (useMonthDate) {
          initParam = {
            sDate: getMonthDate(sDate),
            eDate: getMonthDate(eDate),
          };
        }
      }

      //   유형구분 initData 값 초기 셋팅
      if (typeof initData.pltfomTpCode !== 'undefined') {
        initParam = {
          ...initParam,
          pltfomTpCode: initData.pltfomTpCode,
        };
      } else {
        initParam = {
          ...initParam,
          pltfomTpCode: '00',
        };
      }
      if (typeof initData.advrtsTpCode !== 'undefined') {
        advrtsTpCode = initData.advrtsTpCode;
        initParam = {
          ...initParam,
          advrtsTpCode: advrtsTpCode,
        };
      }

      if (typeof initData.advrtsPrdtCode !== 'undefined') {
        advrtsPrdtCode = initData.advrtsPrdtCode;
        initParam = {
          ...initParam,
          advrtsPrdtCode: advrtsPrdtCode,
        };
      }
    }

    //== 외부연동 디폴트설정
    if (!noneExternalFilter && itlTpCode === null) {
      //   initParam = {
      //     ...initParam,
      //     itlTpCode: null,
      //   };
      if (externalUseRtb) {
        initParam = {
          ...initParam,
          itlTpCode: '03',
        };
      }
    }

    const temp = [].concat(pCodeList);
    temp.unshift({
      label: t('전체'),
      value: '00',
    });

    if (pltfomTpCodeDetailFilter) {
      for (let pltfomTpCode of pltfomTpCodeDetailFilter) {
        let str = '';
        switch (pltfomTpCode) {
          case '03':
            str = '모바일웹';
            break;
          case '04':
            str = 'APP';
            break;
          case '05':
            str = '미승인';
            break;
          default:
            str = '알수없음';
        }
        temp.push({
          label: t(str),
          value: pltfomTpCode,
        });
      }
    }

    const platformCodeList = temp;
    getParam(initParam);

    this.state = {
      platformCodeList,
      params: {
        ...initParam,
      },
    };
  }

  closePopover = null;

  componentDidUpdate(prevProps, prevState) {
    const { initialization, getParam } = this.props;
    let { params } = this.state;
    const { params: prevParams } = prevState;
    if (initialization) {
      if (JSON.stringify(initParam) !== JSON.stringify(params)) {
        this.setState({
          ...this.state,
          params: {
            ...initParam,
          },
        });
        params = { ...initParam };
      } else {
        getParam(params);
      }
    }
    if (JSON.stringify(params) !== JSON.stringify(prevParams)) {
      getParam(params);
    }
  }

  /**
   * 날짜 필터
   */
  handleOnchangeDate = (date) => {
    const { startDate, endDate } = date;
    if (startDate !== null && endDate !== null) {
      this.setState({
        ...this.state,
        params: {
          ...this.state.params,
          sDate: startDate,
          eDate: endDate,
        },
      });
    }
  };

  /**
   * 비교날짜 필터
   */
  handleOnchangeDiffDate = (date) => {
    const { startDate, endDate } = date;
    if (startDate !== null && endDate !== null) {
      this.setState({
        ...this.state,
        params: {
          ...this.state.params,
          diffSDate: startDate,
          diffEDate: endDate,
        },
      });
    }
  };

  /**
   * 날짜 필터
   */
  handleOnchangeReferDate = (date) => {
    if (date !== null) {
      this.setState({
        ...this.state,
        params: {
          ...this.state.params,
          ...date,
        },
      });
    }
  };

  /**
   * 유형 구분
   * @param {object} e
   */
  handleOnPlatformCode = (newParams) => {
    this.setState({
      ...this.state,
      params: newParams,
    });
  };

  /**
   * 디스플레이 필터 선택 관련
   */
  handleOnClickDisplayFilter = ({ params }) => {
    this.setState({
      ...this.state,
      params,
    });
  };

  /**
   * 시간 필터 이벤트
   * @param {integer} hh
   */
  handleOnTimeChange = (hh) => {
    const { params } = this.state;
    const newParams = {
      ...params,
    };

    newParams['statsHh'] = hh;

    this.setState({
      ...this.state,
      params: newParams,
    });
  };

  /**
   * 외부연동 필터 이벤트
   * @param {string} externalCode
   */
  handleOnExternalChange = (externalCode) => {
    const { params } = this.state;
    const newParams = {
      ...params,
    };

    newParams['itlTpCode'] = externalCode;

    this.setState({
      ...this.state,
      params: newParams,
    });
  };

  /**
   * 외부연동 필터 이벤트
   * @param {string} externalCode
   */
  handleExternalId = (externalCode) => {
    const { params } = this.state;
    const newParams = {
      ...params,
    };

    newParams['itlTpCode'] = externalCode;

    this.setState({
      ...this.state,
      params: newParams,
    });
  };

  handleProductTargeting = () => {
    const { params } = this.state;

    const newParams = {
      ...params,
      advrtsTpCode: '04,10,16,17,34',
      advrtsPrdtCode: '01',
    };
    this.setState({
      ...this.state,
      params: newParams,
    });
  };

  handleGetManager = (newParams) => {
    this.setState({
      ...this.state,
      params: newParams,
    });
  };

  render() {
    const {
      handleOnchangeDate,
      handleOnchangeDiffDate,
      handleOnPlatformCode,
      handleOnClickDisplayFilter,
      handleOnExternalChange,
      handleOnTimeChange,
      handleProductTargeting,
      handleOnchangeReferDate,
      handleGetManager,
    } = this;
    const { params, platformCodeList } = this.state;
    const {
      getParam,
      t,
      initialization,
      nonePltfomTpCodeFilter, //유형구분상세 (전체, 웹, 모바일, 모바일웹, APP)
      noneDisplayFilter,
      noneDate,
      useDiffDate,
      useTimeFilter = false,
      noneExternalFilter,
      displayFilterList,
      productTargeting,
      toolTip,
      useMonthDate,
      useSingleDate,
      externalUseRtb,
      dateId,
      useManagerFilter,
      useSizeType,
      useMediaTpCode,
      required, //필수컬럼 Object
    } = this.props;

    // 순서대로 디스플레이 상품별, 디스플레이 유형별
    const { advrtsPrdtCode, itlTpCode } = params;

    return (
      <>
        {toolTip !== null && toolTip !== undefined && (
          <>
            <MbTooltip title={toolTip} placement="bottom-start">
              <Icon icon={'faInfoCircle'} color="#c5c6d0" />
            </MbTooltip>
          </>
        )}
        {!noneDate && (
          <DateRangePicker
            initialization={initialization}
            startDateId="startDate"
            endDateId="endDate"
            handleOnChange={handleOnchangeDate}
            initialStartDate={sDate}
            initialEndDate={eDate}
            label={t('날짜')}
            filtered
            useMonthDate={useMonthDate}
          />
        )}
        {useDiffDate && (
          <DateRangePicker
            initialization={initialization}
            startDateId="diffStartDate"
            endDateId="diffEndDate"
            handleOnChange={handleOnchangeDiffDate}
            initialStartDate={diffSDate}
            initialEndDate={diffEDate}
            label={t('비교날짜')}
            filtered
          />
        )}

        {useSingleDate && (
          <SingleDate
            id={dateId}
            handleOnChange={handleOnchangeReferDate}
            initialDate={!useMonthDate ? stdDttm : statsMth}
            label={t('기준날짜')}
            useMonthDate={useMonthDate}
          />
        )}
        {!nonePltfomTpCodeFilter && (
          <FilterCollection
            label={t('유형 구분')}
            name="pltfomTpCode"
            params={params}
            type="radio"
            list={platformCodeList}
            callBack={handleOnPlatformCode}
            labelKey="label"
            valueKey="value"
          />
        )}

        {!noneDisplayFilter && (
          <DisplayFilter
            id="mb-daily-statistics-display-popper"
            handleOnClickFilter={handleOnClickDisplayFilter}
            advrtsPrdtCode={advrtsPrdtCode}
            displayFilterList={displayFilterList}
            params={params}
            required={
              typeof required !== 'undefined'
                ? required.type === 'DisplayFilter'
                  ? required.val
                  : null
                : null
            }
          />
        )}
        {!noneExternalFilter && (
          <ExternalFilter
            itlTpCode={itlTpCode}
            handleOnExternalChange={handleOnExternalChange}
            useRtb={externalUseRtb}
          />
        )}
        {useTimeFilter && (
          <TimeFilter
            id="mb-daily-statistics-time-popper"
            handleOnTimeChange={handleOnTimeChange}
            params={params}
            useRange={useTimeFilter.useRange}
          />
        )}
        {useManagerFilter && (
          <ManagerFilter
            label={t('영업담당자')}
            name={'contact'}
            params={params}
            getParam={getParam}
            handleGetManager={handleGetManager}
          />
        )}
        {useSizeType && (
          <SizeTypeFilter
            label={t('사이즈 형태')}
            name={'sizeType'}
            optionLabelKey={'CODE_DESC'}
            optionValueKey={'CODE_ID'}
            getParam={getParam}
            params={params}
          />
        )}
        {useMediaTpCode && (
          <MediaTpCodeFilter
            label={t('매체 카테고리')}
            name={'crgrNo'}
            optionLabelKey={'CODE_VAL'}
            optionValueKey={'CODE_ID'}
            getParam={getParam}
            params={params}
            style={{ minWidth: 110 }}
          />
        )}
        {productTargeting && (
          <MbButton filterButton clickEvent={handleProductTargeting}>
            상품타게팅(SR+CW+RC+SP+PR)
          </MbButton>
        )}
      </>
    );
  }
}

export default withTranslation()(
  connect(
    ({ common }) => ({ platformCodeList: common.platformCodeList }),
    null
  )(withRouter(StatisticsCommonFilter))
);
